import { EditorState } from 'draft-js';
import decorator from './modifiers/decorator';
import plaintextToDraft from './parsers/plaintextToDraft';

export default function initializeEditorState(initText = null, ctx) {
  return !initText
    ? EditorState.createEmpty(decorator(ctx))
    : EditorState.moveSelectionToEnd(EditorState.createWithContent(plaintextToDraft(initText), decorator(ctx)));
}
